import * as React from "react";
import { Table, OverlayTrigger, Button } from "react-bootstrap";

import { Loader } from "lib/components/Loader";
import * as Routes from "lib/routes";
import I18n from "lib/I18n";

import { tooltips } from "../../lib/tooltips";
import style from "./style.module.css";
import { BsBoxArrowUpRight, BsWindow, BsX } from "react-icons/bs";
import { getStore } from "../../store";
import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { BigqueryTable } from "lib/Api";

interface IconButtonProps {
  icon: React.ReactNode;
  messageKey: string;
  onClick?(e: unknown): boolean;
  href?: string;
  disabled?: boolean;
}

function IconButton(props: IconButtonProps) {
  const { icon, messageKey, onClick, href, disabled } = props;

  return (
    <OverlayTrigger delay={500} placement="top" overlay={tooltips[messageKey]}>
      <Button
        variant="light"
        size="sm"
        onClick={onClick}
        href={href}
        className={disabled ? "disabled" : undefined}
        target={href ? "_blank" : undefined}
      >
        {icon}
      </Button>
    </OverlayTrigger>
  );
}

export const List = observer(() => {
  const store = getStore().list;
  useEffect(() => {
    store.listTables();
  }, []);

  const renderLinkToEventMaster = (eventMasterId: number) => {
    if (eventMasterId) {
      const path = Routes.define_event_master_path(eventMasterId);
      return (
        <IconButton
          icon={<BsBoxArrowUpRight />}
          messageKey="move_to_event_master"
          href={path}
        />
      );
    }
    return (
      <IconButton
        icon={<BsBoxArrowUpRight />}
        messageKey="event_master_not_found"
        disabled={true}
      />
    );
  };

  const renderTable = (table: BigqueryTable, index: number) => {
    const onShowDdl = (_: unknown) => {
      getStore().ddl.getDdl(table.name);
      return false;
    };
    const onDelete = (_: unknown) => {
      if (confirm(I18n.t("bigquery_table_viewer.messages.confirm_deletion"))) {
        store.deleteTable(table.name);
      }
      return false;
    };

    return (
      <tr key={index}>
        <td>{table.name}</td>
        <td>{table.rows}</td>
        <td>{table.usedSize}</td>
        <td>
          <IconButton
            onClick={onShowDdl}
            icon={<BsWindow />}
            messageKey="show_ddl"
          />
          &nbsp;
          {renderLinkToEventMaster(table.eventMasterId)}
          &nbsp;
          <IconButton
            onClick={onDelete}
            icon={<BsX />}
            messageKey="delete_table"
          />
        </td>
      </tr>
    );
  };

  const renderContent = () => {
    return (
      <div className={style.root}>
        <p>
          <Button onClick={() => store.listTables()}>
            {I18n.t("bigquery_table_viewer.label.reload_tables")}
          </Button>
        </p>
        <div className={style.table}>
          <Table
            bordered
            striped
            hover
            size="sm"
            className="table-bigquery-table"
          >
            <thead>
              <tr>
                <th>{I18n.t("bigquery_table_viewer.label.name")}</th>
                <th>{I18n.t("bigquery_table_viewer.label.rows")}</th>
                <th>{I18n.t("bigquery_table_viewer.label.used_size")}</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {store.tables.map((table, index) => renderTable(table, index))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  };

  return <Loader show={store.isLoading}>{renderContent()}</Loader>;
});
